import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp'
import classNames from 'classnames'
import Collections, { ViewType } from 'components/Collections'
import {
  HoverEvent,
  ListType as CollectionListType,
  PdsData,
  ViewEvent,
} from 'components/Collections/Collections'
import PdsMarker from 'components/Map/components/PdsMarker'
import { MarkerEvent } from 'components/Map/data/model'
import Search from 'components/Search'
import { RootState } from 'data/reducer'
import { useAppSelector } from 'data/store/hooks'
import { mapConfig } from 'lib/config'
import { PageType, useNavigation } from 'lib/hooks'
import React, { useCallback, useState } from 'react'

interface LandingPageProps {
  markersGroup: H.map.Group
  collectionMarkers: PdsData[]
  collectionView: ViewType
  handleCollectionsView: (event: ViewEvent) => void
}

const LandingPage = ({
  markersGroup,
  collectionMarkers,
  collectionView,
  handleCollectionsView,
}: LandingPageProps): JSX.Element => {
  const { goTo } = useNavigation()
  const [hoverId, setHoverId] = useState<string>()

  const isSearchAutocompleteExpanded = useAppSelector(
    (state: RootState) => state.search.lastUpdatedList !== undefined
  )

  const handleSearchQuerySelection = useCallback(
    (value: string) => {
      if (value === '') {
        goTo({ type: PageType.LANDING, url: '/' })
      } else {
        const encodedValue = encodeURIComponent(value)

        goTo({ type: PageType.DISCOVERY, url: `/${mapConfig.url.path.discover}/${encodedValue}` })
      }
    },
    [goTo]
  )

  const handleCollectionItemHover = useCallback((event: HoverEvent) => {
    if (event.type === CollectionListType.places) {
      event.id !== undefined ? setHoverId(event.id) : setHoverId('')
    }
  }, [])

  const handleMarkerCreation = useCallback(
    (marker: H.map.Marker): void => {
      markersGroup.addObject(marker)
      // Trigger the custom event that will update map's look at data
      // if (markersGroupRef.current.getObjects().length === searchList.length) {
      markersGroup.dispatchEvent(new H.util.Event(MarkerEvent.MarkersUpdate))
      // }
    },
    [markersGroup]
  )

  const handleMarkerFocus = useCallback(
    (id: string): void => {
      setHoverId(id)
    },
    [setHoverId]
  )

  const handleMarkerFocusOut = useCallback((): void => {
    setHoverId('')
  }, [setHoverId])

  const handleMarkerClick = useCallback(
    (id: string): void => {
      goTo({ type: PageType.PDC, url: `/${mapConfig.url.path.pdc}/${id}` })
    },
    [goTo]
  )

  return (
    <div className="Map__landing-page">
      {collectionView === ViewType.collectionsCard && (
        <div className="Map__card Map__search">
          <Search key="landing" onQuerySelect={handleSearchQuerySelection} />
        </div>
      )}
      <Collections
        className={classNames('Map__collections', {
          'Map__collections--hidden': isSearchAutocompleteExpanded,
        })}
        onViewChange={handleCollectionsView}
        view={collectionView}
        onItemHover={handleCollectionItemHover}
      />

      {collectionMarkers.map((marker, index) => (
        <PdsMarker
          isStared={true}
          cursor="pointer"
          key={`${marker.id}-${index}`}
          id={marker.id}
          isHovered={hoverId === marker.id}
          categoryId={marker.category}
          lat={marker.lat}
          lng={marker.lng}
          zIndex={
            hoverId === marker.id ? collectionMarkers.length + 1 : collectionMarkers.length - index
          }
          onMarkerCreate={handleMarkerCreation}
          onMouseEnter={handleMarkerFocus}
          onMouseLeave={handleMarkerFocusOut}
          onClick={handleMarkerClick}
        />
      ))}
    </div>
  )
}

export default LandingPage
